import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentSchedule, PurchaseOrder, PurchaseOrderAccounting } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0720. 発注案件管理会計一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_accountings
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const purchaseOrderAccountings = (props: Props): Promise<PurchaseOrderAccounting[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/purchase_order_accountings`);
};

export const usePurchaseOrderAccountings = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderAccountings(props),
  });
};

export const usePurchaseOrderAccountingsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'purchase_order_accountings'];
};
